import { Component, ViewEncapsulation } from '@angular/core';
import { SupportTicketModalActionService } from '../support-ticket-modal/support-ticket-modal-action.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'support'
  }
})
export class SupportComponent {

  constructor(
    private supportTicketModalActionService: SupportTicketModalActionService
  ) { }

  openSupportTicketModal(): void {
    this.supportTicketModalActionService.open();
  }

}
